import axios from 'axios';

// axios.defaults.baseURL = 'http://localhost:8080/api';
axios.defaults.baseURL = 'https://barragemradioclube.com.br/api';

axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if(token){
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default axios;